import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=2f7ebf14&scoped=true&"
import script from "./bindAccount.vue?vue&type=script&lang=js&"
export * from "./bindAccount.vue?vue&type=script&lang=js&"
import style0 from "./bindAccount.vue?vue&type=style&index=0&id=2f7ebf14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ebf14",
  null
  
)

export default component.exports